import "../sass/special-section.scss";

$(function() {

  const slider = $(".custom-carousel-track");

  if(slider.length > 0) {

    slider.slick({
      lazyLoad: "progressive",
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      autoplay: true,
      prevArrow: `<button type="button" class="slick-prev">
                    <svg width="16" height="29" viewBox="0 0 16 29" xmlns="http://www.w3.org/2000/svg">
                      <path d="M-0.000395478 14.0347C-0.000395454 13.5316 0.191685 13.0286 0.575037 12.6451L12.6444 0.575821C13.4122 -0.19194 14.657 -0.19194 15.4244 0.575821C16.1919 1.34327 16.1919 2.58782 15.4244 3.35564L4.74477 14.0347L15.424 24.7137C16.1915 25.4815 16.1915 26.7259 15.424 27.4933C14.6566 28.2614 13.4118 28.2614 12.644 27.4933L0.574664 15.4243C0.191249 15.0405 -0.000395501 14.5375 -0.000395478 14.0347Z" fill="#1F618D"/>
                    </svg>
                  </button>`,
      nextArrow: `<button type="button" class="slick-next">
                    <svg width="16" height="29" viewBox="0 0 16 29" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.0004 14.9653C16.0004 15.4684 15.8083 15.9714 15.425 16.3549L3.35559 28.4242C2.58783 29.1919 1.34304 29.1919 0.575588 28.4242C-0.191863 27.6567 -0.191863 26.4122 0.575588 25.6444L11.2552 14.9653L0.57596 4.28625C-0.191491 3.51849 -0.191491 2.27407 0.57596 1.50669C1.34341 0.73855 2.5882 0.73855 3.35597 1.50669L15.4253 13.5757C15.8087 13.9595 16.0004 14.4625 16.0004 14.9653Z" fill="#1F618D"/>
                    </svg>
                  </button>`,
      focusOnSelect: true,
      responsive: [
            {
              breakpoint: 1200,
              settings: {
               
                slidesToShow: 1,
              },
            },
          ],
    });

  }

  const shareIcon = $("#share-icon");
  const socialNetworks = $(".sticky-bar-mobile a");
  const menu = $('.navbar-collapse');
  
  const toggleSocialNetworks = () => {
      shareIcon.toggleClass("sticky-bar-open");
      socialNetworks.each(function () {
          $(this).toggleClass("show-icons");
      });
  }
  
  shareIcon.on("click", () => {
      toggleSocialNetworks();
      if (menu.hasClass("show")) {
          menu.removeClass("show");
      }
  });


});
  
